import { render, staticRenderFns } from "./cardInfo.vue?vue&type=template&id=0c5228f9&scoped=true&"
import script from "./cardInfo.vue?vue&type=script&lang=js&"
export * from "./cardInfo.vue?vue&type=script&lang=js&"
import style0 from "./cardInfo.vue?vue&type=style&index=0&id=0c5228f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5228f9",
  null
  
)

export default component.exports